import { BRANCHES_COLUMN_NAME, BRANCHES_COLUMN_NAME_TXT } from '../../types/branches';
import ColumnTitle from '~/view/components/ColumnTitle/ColumnTitle';
import './style.scss';

const BranchesListHeaders: React.FC = () => {
  return (
    <div className="d-flex flex-row mb-4 px-8">
      <ColumnTitle<BRANCHES_COLUMN_NAME> title={BRANCHES_COLUMN_NAME_TXT.TAKER} className="w-62-5" />
      <ColumnTitle<BRANCHES_COLUMN_NAME> title={BRANCHES_COLUMN_NAME_TXT.TO_YOU} className="w-37-5" />
    </div>
  );
};

export default BranchesListHeaders;
